var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins, Prop, Emit, Watch, } from 'vue-property-decorator';
import CrudSidesheetMixin from '@/mixins/crud-sidesheet-mixin';
import { ValidationObserver } from 'vee-validate';
var BaseCrudSidesheet = /** @class */ (function (_super) {
    __extends(BaseCrudSidesheet, _super);
    function BaseCrudSidesheet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Visibility of sidesheet from props or from user interaction
         */
        _this.internalVisible = false;
        return _this;
    }
    /**
     * Event emitted when the save button is clicked
     */
    BaseCrudSidesheet.prototype.onSaveButtonClicked = function () {
        return __awaiter(this, void 0, void 0, function () {
            var validationResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validationObserver.validate()];
                    case 1:
                        validationResult = _a.sent();
                        // no validation errors found
                        if (validationResult !== false) {
                            // set sidesheet as loading
                            this.sidesheetLoading = true;
                            // reset validations
                            this.validationObserver.reset();
                            if (this.mode === 'create') {
                                this.$emit('creating');
                            }
                            else if (this.mode === 'update') {
                                this.$emit('updating');
                            }
                            else {
                                this.$emit(this.mode);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Event emitted when the cancel button is clicked
     */
    BaseCrudSidesheet.prototype.onCancelButtonClicked = function () {
        this.handleSidesheetClosed();
    };
    /**
     * Event emitted when the sidesheet visibility is changed by user interaction
     */
    BaseCrudSidesheet.prototype.updateInternalVisible = function (val) {
        this.internalVisible = val;
        if (val) {
            this.handleSidesheetOpened();
        }
        else {
            this.handleSidesheetClosed();
        }
    };
    /**
     * Watch for sidesheet visibility changed by prop interaction
     */
    BaseCrudSidesheet.prototype.onExternalVisibleChanged = function (val, oldVal) {
        // set the internal value when external prop changed
        this.internalVisible = val;
        if (val !== oldVal) {
            if (val) {
                this.handleSidesheetOpened();
            }
            else {
                this.handleSidesheetClosed();
            }
        }
    };
    BaseCrudSidesheet.prototype.handleSidesheetOpened = function () {
        // reset validation
        this.validationObserver.reset();
        // emit a visibility changed event
        this.$emit('visible');
    };
    BaseCrudSidesheet.prototype.handleSidesheetClosed = function () {
        // reset validation
        this.validationObserver.reset();
        // close sidesheet
        this.close();
    };
    Object.defineProperty(BaseCrudSidesheet.prototype, "validationObserver", {
        get: function () {
            return this.$refs.observer;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: Boolean, required: true }),
        __metadata("design:type", Boolean)
    ], BaseCrudSidesheet.prototype, "value", void 0);
    __decorate([
        Prop({ type: String, required: false, default: '350' }),
        __metadata("design:type", String)
    ], BaseCrudSidesheet.prototype, "width", void 0);
    __decorate([
        Prop({ type: String, required: false }),
        __metadata("design:type", String)
    ], BaseCrudSidesheet.prototype, "title", void 0);
    __decorate([
        Emit('cancelled'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BaseCrudSidesheet.prototype, "onCancelButtonClicked", null);
    __decorate([
        Watch('value', { immediate: false, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], BaseCrudSidesheet.prototype, "onExternalVisibleChanged", null);
    BaseCrudSidesheet = __decorate([
        Component({
            components: {
                'validation-observer': ValidationObserver,
            },
        })
    ], BaseCrudSidesheet);
    return BaseCrudSidesheet;
}(Mixins(CrudSidesheetMixin)));
export default BaseCrudSidesheet;
